import { Typography } from "@mui/material";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";

const BackgroundPageLoader = () => {
        const language = useSelector((state: RootState) => state.language.language);
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                margin: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
                flexDirection: 'column'
            }}
        >
            <div className="container">

                <div className="cloud front">
                    <span className="left-front"></span>
                    <span className="right-front"></span>
                </div>
                <span className="sun sunshine"></span>

                <span className="sun"></span>
                <div className="cloud back">
                    <span className="left-back"></span>
                    <span className="right-back"></span>
                </div>
            </div>
            <Typography
                variant="h5"
                sx={{
                    mb: 1,
                    color: '#000',
                    margin: '10px 20px !important',
                    fontWeight: '500',
                    textAlign: 'center',
                }}
            >
                {language === 'english' ? 'Your health, our priority – Find the nearest hospital instantly!' : 'आपले आरोग्य, आमचे प्राधान्य - जवळचे रुग्णालय त्वरित शोधा!'}
            </Typography>

        </div>
    );
};
export default BackgroundPageLoader;
